var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeLineFlagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00423 11.4048V12.5185C8.87387 12.7169 9.3926 13.1135 9.3926 13.3882C9.3926 13.8001 8.33988 14.4104 6.73792 14.4104C5.13595 14.4104 4.08323 13.8001 4.08323 13.3882C4.08323 13.0983 4.60197 12.7169 5.4716 12.5185V11.4048C4.00695 11.6794 3 12.4422 3 13.3882C3 14.5782 4.60196 15.4936 6.72266 15.4936C8.84336 15.4936 10.4453 14.5935 10.4453 13.3882C10.4606 12.4422 9.46889 11.6794 8.00423 11.4048Z",
    fill: "#7F8FA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6819 4.57009L12.9177 2.78505C13.0245 2.61722 13.0398 2.40363 12.9482 2.22054C12.8567 2.03746 12.6736 1.93067 12.4753 1.93067H7.28794V1.53399C7.28794 1.22885 7.04383 1 6.75396 1C6.46408 1 6.18945 1.24411 6.18945 1.53399V13.0071C6.18945 13.3122 6.43356 13.5411 6.72344 13.5411C7.01332 13.5411 7.25743 13.297 7.25743 13.0071V7.20952H12.4447C12.6431 7.20952 12.8262 7.10272 12.9177 6.91964C13.0092 6.73656 12.994 6.52297 12.8872 6.35514L11.6819 4.57009Z",
    fill: "#7F8FA4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLineFlagIcon);
export default __webpack_public_path__ + "static/media/timeLineFlagIcon.c85dc0d9.svg";
export { ForwardRef as ReactComponent };